export const ApiConfig = {
    baseUrl: import.meta.env.VITE_API_BASE_URL,

    // Default AuthKeys
    defaultToken: import.meta.env.VITE_APP_DEFAULT_KEY_CUSTOMER,
    defaultSuperAdmin: import.meta.env.VITE_APP_DEFAULT_SUPER_ADMIN,
    defaultFuelAdmin: import.meta.env.VITE_APP_DEFAULT_FUEL_STATION,
    defaultAdmin: import.meta.env.VITE_APP_DEFAULT_ADMIN,
    
    // Version
    ver_superadmin: import.meta.env.VITE_APP_Version_superadmin,
    ver_admin: import.meta.env.VITE_APP_Version_admin,
    ver_refinery: import.meta.env.VITE_APP_Version_refinery,
    ver_user: import.meta.env.VITE_APP_Version_user,

    // Google Map
    googleMapKey: import.meta.env.VITE_APP_Google_Map,

    // Recaptcha
    recaptchaKey: import.meta.env.VITE_APP_Recaptcha_Key,

    // PubNub
    pubnubKey: import.meta.env.VITE_APP_PUBLISH_KEY,
    pubnubSecret: import.meta.env.VITE_APP_SUBSCRIBE_KEY,
    pubnubUUID: import.meta.env.VITE_APP_UUID,
}
